export const PRIV_ACTIONS = {
  SET_COURSE_INSTANCE_PRIV: 'SET_COURSE_INSTANCE_PRIV',
  SET_GLOBAL_PRIV: 'SET_GLOBAL_PRIV',
  SET_CI_INSTRUCTOR: 'SET_CI_INSTRUCTOR',
  RESET_PRIVILEGES: 'RESET_PRIVILEGES',
}
